import { CacheModel } from './model';
import { action } from 'mobx';
import {ArtistSchema, TrackSchema} from '../../types/schema';

export class CacheController {
  constructor(
    private model: CacheModel
  ) {

  }

  @action
  addTrack = (track: TrackSchema) => {
    this.model.track[track.identity] = track;
  };

  @action
  addTracks = (tracks: Array<TrackSchema>) => {
    tracks.forEach(this.addTrack);
  }

  @action
  addArtist = (artist: ArtistSchema) => {
    this.model.artist[artist.identity] = artist;
  }

  @action
  addArtists = (artists: Array<ArtistSchema>) => {
    artists.forEach(this.addArtist);
  }
}